import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./steps.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";

export const ElearningHomeSteps = () => {
  return (
    <section className={styles.section_steps}>
      <div className="container">
        <h2 className={styles.title}>
          How to <span className={"color-orange"}>Enrol</span>
        </h2>
        <div className={styles.steps_wrapper}>
          <div className={styles.line}></div>
          <ul>
            <li>
              <Image
                className={styles.step_icon}
                width={100}
                height={100}
                src={getAssets("/assets/images/elearning/training-page.webp")}
                alt="icon"
              />
              <h4 className={styles.step_num}>Step 1</h4>
              <div className={styles.step_text}>
                Go to the official UniSearch Complete IELTS Training page
              </div>
            </li>
            <li>
              <Image
                className={styles.step_icon}
                width={100}
                height={100}
                src={getAssets(
                  "/assets/images/elearning/application-form.webp"
                )}
                alt="icon"
              />
              <h4 className={styles.step_num}>Step 2</h4>
              <div className={styles.step_text}>
                Complete the online application form
              </div>
            </li>
            <li>
              <Image
                className={styles.step_icon}
                width={100}
                height={100}
                src={getAssets(
                  "/assets/images/elearning/registration-fee.webp"
                )}
                alt="icon"
              />
              <h4 className={styles.step_num}>Step 3</h4>
              <div className={styles.step_text}>Pay the registration fee</div>
            </li>
            <li>
              <Image
                className={styles.step_icon}
                width={100}
                height={100}
                src={getAssets("/assets/images/elearning/acknowledgement.webp")}
                alt="icon"
              />
              <h4 className={styles.step_num}>Step 4</h4>
              <div className={styles.step_text}>
                Get instant seat booking and acknowledgement
              </div>
            </li>
          </ul>
        </div>

        {/* <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={6} md={6}>
            steps
          </Grid>
        </Grid> */}
      </div>
    </section>
  );
};

export default ElearningHomeSteps;
